import React from 'react'
import { connect } from 'react-redux'
import queryString from 'query-string'
import { setLanguage } from '../actions/language'
import { LANG_PARAM } from '../util/language_v3'

class LangParamHandler extends React.Component {
    componentDidMount(){
        let queryParams = queryString.parse(window.location.href.split('?')[1]);
        this.props.dispatch(setLanguage(queryParams[LANG_PARAM]));
    }

    render()  {
        return (
            <></>
        );
    }
}


const mapStateToProps = (state, ownProps) => {
    return {
        strings: state.language.strings,
    }
}

export default connect(mapStateToProps)(LangParamHandler);
